import { IconButton } from '@ksyos/design-system';
import { translateKey } from '../../translate';

interface IImageThumbnailProps {
    onClick?: () => void;
    onRemove?: () => void;
    src: string;
}

export function ImageThumbnail(props: IImageThumbnailProps) {
    return (
        <div style={{ position: 'relative', width: '120px', height: '120px' }}>
            {props.onRemove !== undefined && (
                <IconButton
                    icon="close"
                    labelText={translateKey('common.remove')}
                    onClick={props.onRemove}
                    size="small"
                    style={{
                        position: 'absolute',
                        right: '4px',
                        top: '4px',
                    }}
                    variant="filled"
                />
            )}
            {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
            <img
                onClick={props.onClick}
                src={props.src}
                style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                    objectPosition: 'center top',
                    cursor: props.onClick !== undefined ? 'pointer' : 'auto',
                }}
            />
        </div>
    );
}
